module.exports = __webpack_public_path__ + "img/microsoft-logo.770bcbea.svg";